import { CustomFieldDataType } from "types/enum";

// Must stay `import type`: a value import here would defeat the split described below.
import type { CustomFieldValue } from "commonComponents/entity/customField/utils/customFieldValues.util";

/**
 * Name/value conversion for the custom field data-type enum.
 *
 * This is the only home for these symbols. They were split out of `customFieldValues.util`, which
 * reaches every custom field handler, so keep this module free of imports that lead back there.
 */

export type CustomFieldDataTypeName = CustomFieldValue["dataType"] | "None";

export function customFieldDataTypeName(dataType: CustomFieldDataType): CustomFieldDataTypeName {
    return CustomFieldDataType[dataType] as CustomFieldDataTypeName;
}

export function customFieldDataTypeValue(name: CustomFieldDataTypeName): CustomFieldDataType {
    return CustomFieldDataType[name];
}
